module.exports = __webpack_public_path__ + "static/assets/29f39753b8ce643de19b918af47653fc.png";